var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "#1779DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9471 4.77355C16.3021 5.06644 16.3525 5.59167 16.0596 5.94668L8.91046 14.6123C8.76057 14.794 8.49 14.8154 8.31338 14.6595L4.44874 11.2496C4.10364 10.9451 4.07072 10.4184 4.37523 10.0733C4.67973 9.72824 5.20634 9.69533 5.55144 9.99983L8.44716 12.5549L14.7739 4.88605C15.0668 4.53103 15.5921 4.48067 15.9471 4.77355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxFilled);
export default __webpack_public_path__ + "static/media/CheckboxFilled.9019090c1b0eb6f02903673298c022e2.svg";
export { ForwardRef as ReactComponent };